<div class="container">
  <div class="row">
    <div class="col-md-2">
      <div id="mySidenav" class="sidenav">
        <a href="javascript:void(0)" class="closebtn" (click)="closeNav()"
          >&times;</a
        >
        <a [routerLink]="['./']">AllBooks</a>
        <a [routerLink]="['./addBook']" routerLinkActive="active">add Book</a>
        <a [routerLink]="['./posts']" routerLinkActive="active">Posts</a>
        <a [routerLink]="['./addPost']" routerLinkActive="active">Add Post </a>
        <a [routerLink]="['./users']" routerLinkActive="active">Users </a>
      </div>

      <div id="main">
        <span style="font-size:30px;cursor:pointer" (click)="openNav()"
          >&#9776; menu</span
        >
      </div>
    </div>
    <div class="col-md-10 mt-2">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
